import { render, staticRenderFns } from "./ReservasBarco.vue?vue&type=template&id=13697190&scoped=true"
import script from "./ReservasBarco.vue?vue&type=script&lang=js"
export * from "./ReservasBarco.vue?vue&type=script&lang=js"
import style0 from "./ReservasBarco.vue?vue&type=style&index=0&id=13697190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13697190",
  null
  
)

export default component.exports